import React, { useState } from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import TextToVideoTab from './tabs/TextToVideoTab';
import ImageToVideoTab from './tabs/ImageToVideoTab';
import ReferenceToVideoTab from './tabs/ReferenceToVideoTab';
import './Veo2Generator.scss';
import Veo2ResultPanel from './Veo2ResultPanel';

const Veo2Generator = () => {
  const { t } = useI18n();
  const TABS = [
    { key: 'text', label: t('videoGeneration.veo.tabs.textToVideo') },
    { key: 'image', label: t('videoGeneration.veo.tabs.imageToVideo') },
    { key: 'reference', label: t('videoGeneration.veo.tabs.referenceToVideo') }
  ];
  const [activeTab, setActiveTab] = useState('text');
  const [resultsByTab, setResultsByTab] = useState({
    text: null,
    image: null,
    reference: null
  });
  const [generatingByTab, setGeneratingByTab] = useState({
    text: false,
    image: false,
    reference: false
  });

  const handleResult = (tabKey, payload) => {
    setResultsByTab((prev) => ({ ...prev, [tabKey]: payload }));
  };
  const handleGenerating = (tabKey, flag) => {
    setGeneratingByTab((prev) => ({ ...prev, [tabKey]: flag }));
  };

  const renderTab = () => {
    if (activeTab === 'text') return <TextToVideoTab onResult={(payload)=>handleResult('text', payload)} onGeneratingChange={(flag)=>handleGenerating('text', flag)} />;
    if (activeTab === 'image') return <ImageToVideoTab onResult={(payload)=>handleResult('image', payload)} onGeneratingChange={(flag)=>handleGenerating('image', flag)} />;
    return <ReferenceToVideoTab onResult={(payload)=>handleResult('reference', payload)} onGeneratingChange={(flag)=>handleGenerating('reference', flag)} />;
  };

  return (
    <section className="veo2-generator">
      <div className="veo2-generator__inner">
        <div className="veo2-settings">
          <div className="veo2-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                className={`veo2-tab ${activeTab === tab.key ? 'is-active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="veo2-settings__body">
            {renderTab()}
          </div>
        </div>

        <Veo2ResultPanel result={resultsByTab[activeTab]} t={t} isGenerating={generatingByTab[activeTab]} />
      </div>
    </section>
  );
};

export default Veo2Generator;
